module.exports = __webpack_public_path__ + "img/desktop-step03.cb0fdf57.svg";